import globalIP from '@/GlobelIP';
import axios from 'axios';
import React from 'react';
import { useEffect, useState } from 'react';
import { Message, toaster } from 'rsuite';

export default function useCategory(selectedCategoryCode) {
  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  const [categorydata, setCategorydata] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const allData = [];
    const response2 = await fetch(`${globalIP}/api/mstcategories`);
    const pageJson2 = await response2.json();
    const allData2 = [];
    for (let page = 1; page <= pageJson2.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mstcategories?populate=*&pagination[page]=${page}&sort[0]=id`
      );
      const pageJson = await pageResponse.json();
      const processedData = pageJson.data.map(item => ({
        label: item.attributes.CategoryName,
        value: item.attributes.CategoryCode
      }));
      allData2.push(...processedData);
    }

    setCategorydata(allData);
  };

  const [category, setCategory] = useState({
    CategoryCode: '',
    CategoryName: '',
    ShortName: '',
    dis: 'Continue'
  });

  const url = `${globalIP}/api/mstcategories`;
  const submit1 = async e => {
    e.preventDefault();

    const trimmedCategoryName = category.CategoryName?.trim();
    const trimmedCategoryShort = category.ShortName?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>._?\/+=*&^%$#@!~`()\\]/;
    // Validate inputs
    if (trimmedCategoryName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.Category}.
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }
    if (trimmedCategoryShort === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Short Name.
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }
    if (specialCharPattern.test(trimmedCategoryName)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.Category} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }
    try {
      const { data: catefilterData } = await axios.get(
        `${globalIP}/api/mstcategories?filters[CategoryName][$eqi]=${trimmedCategoryName}`
      );
      const { data: catefilterDatacode } = await axios.get(
        `${globalIP}/api/mstcategories?populate=*`
      );
      const nextCode = catefilterDatacode.meta.pagination.total + 1;
      const validCategorydata = categorydata.filter(item => item?.attributes?.ShortName);
      const existingCategoryShort = validCategorydata.find(
        item => item.attributes.ShortName.toLowerCase() === trimmedCategoryShort.toLowerCase()
      );

      if (catefilterData.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.Category} {trimmedCategoryName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      if (existingCategoryShort) {
        toaster.push(
          <Message showIcon type="warning">
            Short Name {trimmedCategoryShort} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      // Prepare form data
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          ...category,
          CategoryName: trimmedCategoryName,
          CategoryCode: `CAT-${nextCode.toString().padStart(3, '0')}`,
          ShortName: trimmedCategoryShort
        })
      );
      // Make POST request
      const response = await fetch(url, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        await fetchData(); // Refresh data
        toaster.push(
          <Message showIcon type="success">
            Data Saved Successfully.
          </Message>,
          { placement: 'topCenter' }
        );
        // Reset the category form
        setCategory({
          CategoryCode: '',
          CategoryName: '',
          ShortName: '',
          dis: 'Continue'
        });
      } else {
        console.error('Failed to save data');
        toaster.push(
          <Message showIcon type="error">
            Failed to save data. Please try again.
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } catch (error) {
      console.error('Error occurred:', error);
      toaster.push(
        <Message showIcon type="error">
          An error occurred. Please try again later.
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  const [productType, setProductType] = useState({
    ProductTypeCode: '',
    ProductTypeName: '',
    CategoryCode: '',
    dis: 'Continue'
  });

  const url2 = `${globalIP}/api/mstproducttypes`;

  const submit2 = async e => {
    if (selectedCategoryCode) {
      e.preventDefault();
      const trimmedProductTypeName = productType.ProductTypeName?.trim();
      const specialCharPattern = /[{}\[\];:"'|<,>.?\/+=*&^%$#@!~`()]/;
      if (trimmedProductTypeName === '') {
        toaster.push(
          <Message showIcon type="error">
            Please Enter {label[0]?.attributes.ProductType}.
          </Message>,
          { placement: 'topCenter' }
        );
      } else if (specialCharPattern.test(trimmedProductTypeName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.ProductType} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
      } else if (
        productType.ProductTypeName.startsWith(' ') ||
        productType.ProductTypeName.endsWith(' ')
      ) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.ProductType} cannot End with a space.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        try {
          // const { data: profilterData } = await axios.get(
          //   `${globalIP}/api/mstproducttypes?populate=*&filters[ProductTypeName][$eqi]=${trimmedProductTypeName}`
          // );
          const { data: profilterData } = await axios.get(
            `${globalIP}/api/mstproducttypes?populate=*&filters[ProductTypeName][$eqi]=${encodeURIComponent(trimmedProductTypeName)}&filters[Categorycode][$eq]=${selectedCategoryCode}`
          );

          console.log('profilterData ---> ', profilterData);
          const { data: profilterDatacode } = await axios.get(
            `${globalIP}/api/mstproducttypes?populate=*`
          );
          const nextCode = profilterDatacode.meta.pagination.total + 1;

          if (profilterData.data.length) {
            toaster.push(
              <Message showIcon type="warning">
                {label[0]?.attributes.ProductType} {productType.ProductTypeName} with same Category
                already exists.
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            const formData = new FormData();
            formData.append(
              'data',
              JSON.stringify({
                ...productType,
                ProductTypeCode: `PTY-${nextCode.toString().padStart(3, '0')}`,
                Categorycode: selectedCategoryCode,
                dis: 'Continue' // Add the selected category code
              })
            );
            const response = await fetch(url2, {
              method: 'POST',
              body: formData
            });
            if (response.ok) {
              // Wait for data to be fetched before logging
              console.log(productType);

              toaster.push(
                <Message showIcon type="success">
                  Data Save Successfully.
                </Message>,
                { placement: 'topCenter' }
              );
            } else {
              console.error('Failed to save data');
            }
          }
        } catch (error) {
          console.error(error);
        }

        setProductType({
          ProductTypeCode: '',
          ProductTypeName: '',
          CategoryCode: '',
          dis: 'Continue'
        });
      }
    } else {
      toaster.push(
        <Message showIcon type="error">
          Please Select {label[0]?.attributes.Category}.
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };
  const handleInputChange2 = (inputName, value, index) => {
    setProductType({ ...productType, [inputName]: value });
  };
  const handleInputChangemstcat = (inputName, value, index) => {
    setCategory({ ...category, [inputName]: value });
  };

  const [collection, setCollection] = useState({
    MatCollectionCode: '',
    MatCollectionName: '',
    dis: 'Continue'
  });

  const url3 = `${globalIP}/api/mstmaterialcollections`;
  const submit3 = async e => {
    e.preventDefault();

    const trimmedMatCollectionName = collection.MatCollectionName?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>._?\/+=*&^%$#@!~`()\\]/;

    if (trimmedMatCollectionName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.Collection}.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (specialCharPattern.test(trimmedMatCollectionName)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.Collection} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      try {
        const { data: collectnfilterData } = await axios.get(
          `${globalIP}/api/mstmaterialcollections?populate=*&filters[MatCollectionName][$eqi]=${trimmedMatCollectionName}`
        );
        console.log('collectnfilterData ---> ', collectnfilterData);
        const { data: collectnfiltercode } = await axios.get(
          `${globalIP}/api/mstmaterialcollections?populate=*`
        );
        const nextCode = collectnfiltercode.meta.pagination.total + 1;
        if (collectnfilterData.data.length) {
          toaster.push(
            <Message showIcon type="warning">
              {label[0]?.attributes.Collection} {trimmedMatCollectionName} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              ...collection,
              MatCollectionName: trimmedMatCollectionName,
              MatCollectionCode: `COL-${nextCode.toString().padStart(3, '0')}`
            })
          );

          const response = await fetch(url3, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            // await fetchData3(); // Wait for data to be fetched before logging
            console.log(collection);

            toaster.push(
              <Message showIcon type="success">
                Data Save Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error(error);
      }

      // Reset the collection state
      setCollection({
        MatCollectionCode: '',
        MatCollectionName: '',
        dis: 'Continue'
      });
    }
  };

  //  Fetch Data from API End
  const handleInputChange3 = (inputName, value, index) => {
    setCollection({ ...collection, [inputName]: value });
  };

  const [finish, setFinish] = useState({
    FinishCode: '',
    FinishName: '',
    dis: 'Continue'
  });
  const [selectedFinishName, setSelectedFinishName] = useState({
    FinishName: '',
    FinishCode: ''
  });
  const url4 = `${globalIP}/api/mstfinishes`;
  const submit4 = async (e, setData5) => {
    e.preventDefault();
    const trimmedFinishName = finish.FinishName?.trim();
    const encodedFinishName = encodeURIComponent(trimmedFinishName);
    const specialCharPattern = /[{}\[\];:"'|<,>._?+=*^%$#@!~`()]/;

    if (trimmedFinishName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.finish}.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (specialCharPattern.test(trimmedFinishName)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.finish} {trimmedFinishName} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      try {
        const { data: finishN } = await axios.get(
          `${globalIP}/api/mstfinishes?filters[FinishName][$eqi]=${encodedFinishName}`
          // `${globalIP}/api/mstfinishes?populate=*&filters[FinishName][$eqi]=${finish.FinishName.trim()}`
        );
        const { data: finishNcode } = await axios.get(`${globalIP}/api/mstfinishes?populate=*`);
        const nextCode = finishNcode.meta.pagination.total + 1;
        if (finishN.data.length) {
          toaster.push(
            <Message showIcon type="warning">
              {label[0]?.attributes.finish} {trimmedFinishName} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              ...finish,
              FinishName: trimmedFinishName,
              FinishCode: `FIN-${nextCode.toString().padStart(3, '0')}`
            })
          );

          const response = await fetch(url4, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            const newFinish = {
              label: trimmedFinishName,
              value: `FIN-${nextCode.toString().padStart(3, '0')}`
            };
            setData5(prevData => ({
              ...prevData,
              FinishName: newFinish ? newFinish.label : "",
              FinishCode: newFinish ? newFinish.value : ''
            })); toaster.push(
              <Message showIcon type="success">
                Data Saved Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
            setSelectedFinishName(prevData => ({
              ...prevData,
              FinishName: trimmedFinishName,
              FinishCode: `FIN-${nextCode.toString().padStart(3, '0')}` // Ensure FinishCode is updated
            }));
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error(error);
      }

      setFinish({
        FinishCode: '',
        FinishName: '',
        dis: 'Continue'
      });
    }
  };

  const handleInputChange4 = (inputName, value, index) => {
    setFinish({ ...finish, [inputName]: value });
  };

  const [color, setColor] = useState({
    ColorCode: '',
    ColorName: '',
    dis: 'Continue'
  });

  const url5 = `${globalIP}/api/mstcolors`;

  //  Fetch Data from API End
  const [selectedColorName, setSelectedColorName] = useState({
    ColorName: '',
    ColorCode: ''
  });
  const submit5 = async (e, setData5, setColordata) => {
    const trimmedColorName = color.ColorName?.trim();
    const encodedcolorName = encodeURIComponent(trimmedColorName);
    const specialCharPattern = /[{}\[\];:"'|<,>._?+=*^%$#@!~`()]/;

    if (trimmedColorName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.color}.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (specialCharPattern.test(trimmedColorName)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.color} {trimmedColorName} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      try {
        const { data: colorN } = await axios.get(
          `${globalIP}/api/mstcolors?filters[ColorName][$eqi]=${encodedcolorName}`
        );
        const { data: colorNcode } = await axios.get(`${globalIP}/api/mstcolors?populate=*`);
        const nextCode = colorNcode.meta.pagination.total + 1;

        if (colorN.data.length) {
          toaster.push(
            <Message showIcon type="warning">
              {label[0]?.attributes.color} {trimmedColorName} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          e.preventDefault();
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              ...color,
              ColorName: trimmedColorName,
              ColorCode: `CLR-${nextCode.toString().padStart(3, '0')}`
            })
          );

          const response = await fetch(url5, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            const newColor = {
              label: trimmedColorName,
              value: `CLR-${nextCode.toString().padStart(3, '0')}`
            };
            setData5(prevData => ({
              ...prevData,
              ColorName: newColor ? newColor.label : "",
              ColorCode: newColor ? newColor.value : ''
            }));
            toaster.push(
              <Message showIcon type="success">
                Data Saved Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
            setSelectedColorName(prevData => ({
              ...prevData,
              ColorName: trimmedColorName,
              ColorCode: `CLR-${nextCode.toString().padStart(3, '0')}` // Ensure FinishCode is updated
            }));
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error('Error occurred while saving data', error);
      }

      setColor({
        ColorCode: '',
        ColorName: '',
        dis: 'Continue'
      });
    }
  };

  const handleInputChange5 = (inputName, value, index) => {
    setColor({ ...color, [inputName]: value });
  };

  const [hscode, setHscode] = useState({
    hscode: '',
    GstRate: '',
    Description: '',
    dis: 'Continue'
  });

  const url6 = `${globalIP}/api/msthscodes`;
  const submit6 = async e => {
    const trimmedHSN = hscode.hscode?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>.?\/+=*&^%$#@!~`()]/;

    if (trimmedHSN === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.HSN}.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (specialCharPattern.test(trimmedHSN)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.HSN} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      try {
        const { data: hsnname } = await axios.get(
          `${globalIP}/api/msthscodes?filters[hscode][$eqi]=${trimmedHSN}`
        );

        if (hsnname.data.length) {
          toaster.push(
            <Message showIcon type="warning">
              {label[0]?.attributes.HSN} {trimmedHSN} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          e.preventDefault();
          const formData = new FormData();
          formData.append('data', JSON.stringify({ ...hscode, hscode: trimmedHSN }));

          const response = await fetch(url6, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            console.log(hscode);
            toaster.push(
              <Message showIcon type="success">
                Data Save Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error(error);
      }

      setHscode({
        hscode: '',
        Description: '',
        GstRate: '',
        dis: 'Continue'
      });
    }
  };

  //  Fetch Data from API End
  const handleInputChange6 = (inputName, value, index) => {
    setHscode({ ...hscode, [inputName]: value });
  };

  const [material, setMaterial] = useState({
    MaterialCode: '',
    MaterialName: '',
    dis: 'Continue'
  });

  const url7 = `${globalIP}/api/mstmaterials`;
  const submit7 = async e => {
    const { data: prcode } = await axios.get(`${globalIP}/api/mstmaterials?populate=*`);
    const { data: matData } = await axios.get(
      `${globalIP}/api/mstmaterials?populate=*&filters[MaterialName][$eqi]=${material.MaterialName.trim()}`
    );
    const nextCode = prcode.meta.pagination.total + 1;
    if (material.MaterialName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.MaterialName}.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      try {
        if (matData.data.length) {
          toaster.push(
            <Message showIcon type="warning">
              Material {material.MaterialName} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          e.preventDefault();
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              ...material,
              MaterialCode: `MAT-${nextCode.toString().padStart(3, '0')}`
            })
          );

          const response = await fetch(url7, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            console.log(material);
            toaster.push(
              <Message showIcon type="success">
                Data Save Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error(error);
      }

      setMaterial({
        MaterialCode: '',
        MaterialName: '',
        dis: 'Continue'
      });
    }
  };

  //  Fetch Data from API End
  const handleInputChange7 = (inputName, value, index) => {
    setMaterial({ ...material, [inputName]: value });
  };

  const [shape, setShape] = useState({
    ShapeCode: '',
    ShapeName: '',
    dis: 'Continue'
  });

  const url8 = `${globalIP}/api/shape-masters`;
  const submit8 = async e => {
    const trimmedShapeName = shape.ShapeName?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>.?\/+=*&^%$#@!~`()]/;

    // Validate the shape name input
    if (trimmedShapeName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please enter a valid {label[0]?.attributes.Shape}.
        </Message>,
        { placement: 'topCenter' }
      );
      return; // Stop further execution
    }

    if (specialCharPattern.test(trimmedShapeName)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.Shape} {shape.ShapeName} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
      return; // Stop further execution
    }

    try {
      const { data: shapee } = await axios.get(
        `${globalIP}/api/shape-masters?filters[ShapeName][$eqi]=${trimmedShapeName}`
      );
      const { data: shapecode } = await axios.get(`${globalIP}/api/shape-masters?populate=*`);
      const nextCode = shapecode.meta.pagination.total + 1;
      if (shapee.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.Shape} {shape.ShapeName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop further execution
      }

      e.preventDefault(); // Prevent default form submission behavior
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          ...shape,
          ShapeName: trimmedShapeName,
          ShapeCode: `SAP-${nextCode.toString().padStart(3, '0')}`
        })
      );

      // Make the API call to save the new shape
      const response = await fetch(url8, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        // Wait for data to be fetched before logging
        console.log(shape);
        toaster.push(
          <Message showIcon type="success">
            Data saved successfully.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving shape', error);
    }

    // Reset the shape state
    setShape({
      ShapeCode: '',
      ShapeName: '',
      dis: 'Continue'
    });
  };

  const handleInputChange8 = (inputName, value, index) => {
    setShape({ ...shape, [inputName]: value });
  };

  const [season, setSeason] = useState({
    SeasonName: '',
    dis: 'Continue'
  });

  const url9 = `${globalIP}/api/season-masters`;
  const submit9 = async e => {
    if (season.SeasonName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.Season}.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      try {
        const trimmedSeasonName = season.SeasonName?.trim();
        const specialCharPattern = /[{}\[\];:"'|<,>.?\/+=*&^%$#@!~`()]/;
        // Validate the season name
        if (!trimmedSeasonName) {
          toaster.push(
            <Message showIcon type="error">
              Please enter a valid {label[0]?.attributes.Season}.
            </Message>,
            { placement: 'topCenter' }
          );
          return; // Exit if validation fails
        }

        if (specialCharPattern.test(trimmedSeasonName)) {
          toaster.push(
            <Message showIcon type="error">
              {label[0]?.attributes.Season} should not contain special characters.
            </Message>,
            { placement: 'topCenter' }
          );
          return; // Exit if validation fails
        }
        const { data: seasonName } = await axios.get(
          `${globalIP}/api/season-masters?filters[SeasonName][$eqi]=${trimmedSeasonName}`
        );
        // if (ptData.data.length) {
        //   toaster.push(
        //     <Message showIcon type="warning">
        //       Shape {season.SeasonName} already exists.
        //     </Message>,
        //     { placement: 'topCenter' }
        //   );
        // }
        if (seasonName.data.length) {
          toaster.push(
            <Message showIcon type="warning">
              {label[0]?.attributes.Season} {trimmedSeasonName} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
          return; // Exit if season already exists
        } else {
          e.preventDefault();
          const formData = new FormData();
          formData.append('data', JSON.stringify({ ...season }));

          const response = await fetch(url9, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            console.log(season);
            toaster.push(
              <Message showIcon type="success">
                Data Save Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error(error);
      }

      setSeason({
        SeasonName: '',
        dis: 'Continue'
      });
    }
  };

  //  Fetch Data from API End
  const handleInputChange9 = (inputName, value, index) => {
    setSeason({ ...season, [inputName]: value });
  };

  const [ptech, setPtech] = useState({
    PTechName: '',
    PTechcode: '',
    dis: 'Continue'
  });
  const url10 = `${globalIP}/api/mst-ptechniques`;
  const submit10 = async e => {
    if (ptech.PTechName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.P_Technique}.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      try {
        const trimmedPtech = ptech.PTechName?.trim();
        // const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
        const specialCharPattern = /[{}\[\];:"'|<,>.?\/+=*&^%$#@!~`()]/;
        if (!trimmedPtech) {
          toaster.push(
            <Message showIcon type="error">
              Please enter a valid {label[0]?.attributes.P_Technique}.
            </Message>,
            { placement: 'topCenter' }
          );
          return; // Exit if validation fails
        }
        if (specialCharPattern.test(trimmedPtech)) {
          toaster.push(
            <Message showIcon type="error">
              {label[0]?.attributes.P_Technique} should not contain special characters.
            </Message>,
            { placement: 'topCenter' }
          );
          return; // Exit if validation fails
        }
        const { data: pNamee } = await axios.get(
          `${globalIP}/api/mst-ptechniques?filters[PTechName][$eqi]=${trimmedPtech}`
        );
        const { data: pNameCode } = await axios.get(`${globalIP}/api/mst-ptechniques?populate=*`);
        const nextCode = pNameCode.meta.pagination.total + 1;

        if (pNamee.data.length) {
          toaster.push(
            <Message showIcon type="warning">
              {label[0]?.attributes.P_Technique} {ptech.PTechName} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
          return; // Exit if validation fails
        } else {
          e.preventDefault();
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              ...ptech,
              PTechName: trimmedPtech,
              PTechcode: `PTEC-${nextCode.toString().padStart(3, '0')}`
            })
          );

          const response = await fetch(url10, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            console.log(ptech);
            toaster.push(
              <Message showIcon type="success">
                Data Save Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error(error);
      }

      setPtech({
        PTechName: '',
        PTechcode: '',
        dis: 'Continue'
      });
    }
  };

  //  Fetch Data from API End
  const handleInputChange10 = (inputName, value, index) => {
    setPtech({ ...ptech, [inputName]: value });
  };

  return {
    submit1,
    handleInputChangemstcat,
    category,
    submit3,
    handleInputChange3,
    collection,
    submit4,
    handleInputChange4,
    finish,
    submit5,
    handleInputChange5,
    color,
    submit6,
    handleInputChange6,
    hscode,
    submit7,
    handleInputChange7,
    material,
    submit8,
    handleInputChange8,
    shape,
    submit9,
    handleInputChange9,
    season,
    submit10,
    handleInputChange10,
    ptech,
    submit2,
    handleInputChange2,
    productType,
    selectedFinishName,
    setSelectedFinishName,
    selectedColorName,
    setSelectedColorName
  };
}
